import { useEffect, useState } from 'react';
import { toggleGuestWishlist } from '../../api/guestApi';
import { useToast } from '../ToastContext';
import { getLocalItem, getSessionItem } from '../../utils/safeStorage';

const toId = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const WishlistToggle = ({ propertyId, active = false, onChange, className = '', disabled = false }) => {
  const toast = useToast();
  const [isActive, setIsActive] = useState(Boolean(active));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIsActive(Boolean(active));
  }, [active]);

  const handleToggle = async (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (loading || disabled) return;
    const id = toId(propertyId);
    if (!id) return;
    const token =
      getSessionItem('customerAccessToken') ||
      getLocalItem('customerAccessToken');
    if (!token) {
      toast.error('Please login to use wishlist');
      return;
    }
    setLoading(true);
    try {
      const res = await toggleGuestWishlist(id);
      const next = Boolean(res?.in_wishlist);
      setIsActive(next);
      if (onChange) onChange(next);
    } catch (err) {
      toast.error(err.message || 'Unable to update wishlist');
    } finally {
      setLoading(false);
    }
  };

  const baseClass = [
    'inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/70 bg-white/90 text-slate-600 shadow-sm transition',
    isActive ? 'text-rose-600' : 'hover:text-rose-600',
    loading ? 'cursor-wait opacity-70' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={baseClass}
      onClick={handleToggle}
      aria-pressed={isActive}
      aria-label={isActive ? 'Remove from wishlist' : 'Add to wishlist'}
      disabled={disabled || loading}
    >
      <i className={`bi ${isActive ? 'bi-heart-fill' : 'bi-heart'}`} />
    </button>
  );
};

export default WishlistToggle;
